<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="pay-view">
                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="'OG61'"><game-item :locked="true" :id="'OG61'" :num="1"></game-item></div>
                            </div>  
                        </div>                        
                    </div>

                    <div class="text">
                        <p>恭喜绑定成功并获得【阿斗互助礼】，奖励已发放至军师邮件，快去参与本期阿斗吧~</p>
                    </div>
                                   
                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal()"></div>                       
                    </div>
                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.pay-modal{
    position: relative;
    width: 625px;
    height: 485px;
    padding-top: 30px;
    box-sizing: border-box;      
    background-image: url(~@/assets/images/modal/bg-modal-w12-success.png);
}

.title{
    width: 516px;
    height: 52px;
    margin: 0 auto 15px;
    font-weight: 400;
    font-size: 0;
    color: transparent;
    text-align: center;
    background-image: url(~@/assets/images/modal/title-success_w12.png);  
}

.notice{
    text-align: center;
    color: #696560;
}

.pay-view{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 543px;
    height: 232px;
    margin: -15px auto 0;
    background-image: url(~@/assets/images/modal/bg-comfirm.png);
}

.pay-view p{
    padding: 0 20px;
    line-height: 1.8;
}

.pay-view b{
    /* color: #fe5a1e; */
}

.text{
    padding: 0 70px;
    color: #696560;
}

.goods-detail{
    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 118px;
        height: 118px;
        margin: 0 auto;
        background-image: url(~@/assets/images/shop/bg-item.png);
    }

    .goods-pic{
        width: 69px;
        height: 69px;
    }
}

.item-name{
    margin-top: -15px;
    margin-bottom: 10px;
    color: #b0a282;
    text-align: center;
}

.calc-item{
    display: flex;
    align-items: center;
    padding-left: 55px;
    margin-bottom: 10px;
    color: #696560;
    // justify-content: center;

    .price{
        b{
            color: #d33d27;
        }
    }
}

.warn{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%; 
    margin-top: 15px;
    font-size: 20px;
    color: #c2393f;
    text-align: center;
    vertical-align: text-top;
}

.i-warn{
    display: inline-block;
    width: 21px;
    height: 21px;
    margin: 0 5px;
    background-image: url(~@/assets/images/modal/icon-warn.png);
    vertical-align: sub;
}

.u-ctrl{
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 110px;
}

.u-ctrl .u-btn.ok{
    width: 186px;
    height: 56px;
    background-image: url(~@/assets/images/modal/btn-submit.png);    
}

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            gid : '2',
            giftName : '----',
            cost : 599,
            num : 1,
            sendNum : 1,
            score : 0,
            text : '',
            item : {},
            value : 1,
            max: 999,
            type : 1,
            groupid : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.max = this.item.max == -1 ? 999 : this.item.max - this.item.orderNum;
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },         
        apply(){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            this.$post(ajax_url_map.w12_skin_apply,{
                success : (data) => {
                    this.destroyElement();
                    this.$msg_modal('操作成功，奖励将直接发放至您的军师邮件，请注意查收。');

                    //todo
                    this.render_ex_list();
                },
                error : (data) => {
                    this.destroyElement();
                    this.$msg_modal(data.message);
                }
            },{
                id : this.gid,
                gid : this.groupid,
            })
        },        
    },    
}
</script>